import type { z } from "zod";

import { zSchema } from "../../../../entity";

const zIn = zSchema
  .pick({
    id: true,
  })
  .merge(
    zSchema
      .pick({
        email: true,
        phone: true,
        firstName: true,
        lastName: true,
      })

      .partial(),
  );
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
